import { render, staticRenderFns } from "./UhNumberStepperRound.vue?vue&type=template&id=e3562fa4"
import script from "./UhNumberStepperRound.vue?vue&type=script&lang=js"
export * from "./UhNumberStepperRound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports